module.exports = __webpack_public_path__ + "assets/img/relate_line_board.75fb65d5.png";